import DefaultValue from "./default-value";

export default class KickedFromDefaultValue extends DefaultValue {
    constructor(play, fragment, summaryContext) {
        super(play, fragment, summaryContext);
    }

    resolve() {
        const { fieldPosition } = this.play?.contextSnapshot || {};
        return fieldPosition;
    }
}
